import { FC } from "react"
import { Notification } from "../../../types/global/types"
import { Button } from "../../ContactsPage/Button"
import { useTranslation } from "../../../hooks/useTranslation"
import "./styles.scss"

type Props = {
  notification: Notification,
}

export const AttemptedThreeTimesNotification: FC<Props> = ({
  notification,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className="notification"
    >
      <div className="notification__header">
        <div className="notification__title">
          <h3>
            {notification.title.startOfTitle}
            {notification.title.householdName}
            {notification.title.endOfTitle}
          </h3>
          <div className="notification__time">
            {notification.created_at_formatted}
          </div>
        </div>
      </div>

      <div className="notification__buttons">
        <Button title={t("common.research_further")} />
        <Button title={t("common.change_category")} />
      </div>
    </div>
  )
}
